// extracted by mini-css-extract-plugin
export default {"notifications":"Notifications-+xC9R__notifications"};